import { render, staticRenderFns } from "./SyncPayoutInitOrderConfigDialog.vue?vue&type=template&id=29d07c4b&"
import script from "./SyncPayoutInitOrderConfigDialog.vue?vue&type=script&lang=js&"
export * from "./SyncPayoutInitOrderConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports